/**
 * Splits an array into smalle chunks
 *
 * Example:
 *  chunks([1, 2, 3, 4, 5, 6], 2) => [[1, 2], [3, 4], [5, 6]]
 *
 * @param list - array to split
 * @param size - size of the chunks
 */
export function chunks<T>(list: T[], size: number) {
  const results = [];

  const passes = list.length / size;
  for (let i = 0; i < passes; i++) {
    results.push(list.slice(i * size, i * size + size));
  }

  return results;
}
